export default __webpack_public_path__ + "static/img4-2b64484bea39c3bf7dc4dbd346018903.png";